<template>
  <div class="display">
    <h2 class="title">AlphaTenbyte Technology Limited</h2>
  </div>
</template>
<script>
export default {
  name: "Display",
  methods: {
    goAnchor(selector) {
        document.querySelector(selector).scrollIntoView();
    }
  }
};
</script>
<style lang="scss" scoped>
.display {
  position: relative;
  border-color: transparent;
  background: #fff;
  width: 100%;
  height: px2rem(624);
  margin-top: px2rem(60);
  overflow: hidden;
  box-shadow: $section-box-shadow;
  background: url("~@images/main-bg-02.png") no-repeat, url("~@images/main-bg.png") no-repeat center;
  background-size: auto px2rem(523), 100% 100%;
  background-position: center top px2rem(60), center top;
  h2 {
    font-size: px2rem(60);
    color: #ffffff;
    font-weight: bolder;
    letter-spacing: 1px;
    text-align: left;
    margin-top: px2rem(200);
    line-height: 1.3em;
    text-align: center;
    width: 70%;
  }
}
</style>